import { ConnectorInfo } from '@blaze-shared/api-contracts-domain';
import { BaseSchema } from '@blaze-shared/schema-domain';
import { DownloadWorkflowNode } from '@blaze-shared/workflow-domain';

import { NAME_SOURCE_ID, VALUE_SOURCE_ID } from '../../errors';
import {
  getColumnReferencesFromString,
  getNamedInputReferencesFromString,
  getParamReferencesFromString,
  getTagReferencesFromString,
} from '../../references/get-references-from-string';
import {
  WorkflowNodeColumnReference,
  WorkflowNodeNamedInputReference,
  WorkflowNodeParamReference,
  WorkflowNodeTagReference,
} from '../../references/references.models';
import { BaseWorkflowNode, WorkflowNode } from '../../registry/node.registry';

@WorkflowNode('Download')
export class DownloadNode extends BaseWorkflowNode<DownloadWorkflowNode> {
  static readonly VALUE_SOURCE_ID = VALUE_SOURCE_ID;
  static readonly NAME_SOURCE_ID = NAME_SOURCE_ID;

  getColumnReferences(schemas: Map<string | symbol, BaseSchema>): WorkflowNodeColumnReference[] {
    return [
      ...getColumnReferencesFromString(this.node.fileName, schemas, DownloadNode.NAME_SOURCE_ID),
      ...getColumnReferencesFromString(this.node.url, schemas, DownloadNode.VALUE_SOURCE_ID),
    ];
  }

  getTagReferences(schemas: Map<string | symbol, BaseSchema>): WorkflowNodeTagReference[] {
    return [
      ...getTagReferencesFromString(this.node.fileName, schemas, DownloadNode.NAME_SOURCE_ID),
      ...getTagReferencesFromString(this.node.url, schemas, DownloadNode.VALUE_SOURCE_ID),
    ];
  }

  getParamReferences(
    schemas: Map<string | symbol, BaseSchema>,
    connectors: ConnectorInfo[],
  ): WorkflowNodeParamReference[] {
    return [
      ...getParamReferencesFromString(
        this.node.fileName,
        schemas,
        connectors,
        DownloadNode.NAME_SOURCE_ID,
      ),
      ...getParamReferencesFromString(
        this.node.url,
        schemas,
        connectors,
        DownloadNode.VALUE_SOURCE_ID,
      ),
    ];
  }

  getNamedInputReferences(
    schemas: Map<string | symbol, BaseSchema>,
  ): WorkflowNodeNamedInputReference[] {
    return [
      ...getNamedInputReferencesFromString(
        this.node.fileName,
        schemas,
        DownloadNode.NAME_SOURCE_ID,
      ),
      ...getNamedInputReferencesFromString(this.node.url, schemas, DownloadNode.VALUE_SOURCE_ID),
    ];
  }
}
